import { Injectable} from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReconciliationResult } from '../models/reconciliation';

@Injectable({
  providedIn: 'root'
})

export class ReconciliationService {

  baseUrl = environment.apiEndpoint + '/project';

  constructor(private http: HttpClient) {  }

  setReconciliaton(formData: FormData) : Observable<ReconciliationResult> {
    return this.http.post<ReconciliationResult>(this.baseUrl + '/reconciliation', formData);
  }

  GetReconciliationFiles(projectId: string, vendorId: string = null) {
    return this.http.get<any>(this.baseUrl + '/' + projectId + '/reconciliation' + (vendorId ? `/${vendorId}` : ''));
  }

  GetSummary(projectId: string) {
    return this.http.get<any>(this.baseUrl + '/' + projectId + '/reconciliation/summary');
  }

  UploadQC(projectId: string, fileId: string) {
    return this.http.get<any>(this.baseUrl + '/' + projectId + '/reconciliation/quickupdate/' + fileId );
  }

  RollbackAll(projectId: string) {
    return this.http.get<any>(this.baseUrl + '/' + projectId + '/reconciliation/rollback');
  }
  reconcilationFromAPI(projectId: string) : Observable<ReconciliationResult> {
    return this.http.get<ReconciliationResult>(this.baseUrl + '/' + projectId + '/reconciliation/applyReconciliationAPI');
  }
  uploadLink(fileToUpload, projectId) {
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('projectId', projectId);
    return formData;
  }

  uploadLink1(files) {
    if (files === null) {
      return;
    }
    const fileToUpload = files[0] as File;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return formData;
  }

}
